module.exports = __webpack_public_path__ + "static/media/chevron-down.84cf9bde.svg";